module.exports = __webpack_public_path__ + "static/media/CT_2019_30441A.2d876c89.png";